import React from "react";
import { Tag } from "../style";

export const TagItem = ({
  label,
  value,
  checked = false,
  onChange = () => {},
}) => {
  const onClick = () => {
    onChange(value, !checked);
  };
  return (
    <Tag className={checked && "checked"} onClick={onClick}>
      {label}
    </Tag>
  );
};
